// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__9WPXq","label":"input_label__27w_B","err":"input_err__2ZRgg","boder_err":"input_boder_err__3dWHQ"};